<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 0px;position: relative;">
      <template>

        <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="hh" border>

          <el-table-column prop="userName" label="姓名"></el-table-column>
          <el-table-column prop="temprate" label="体温"></el-table-column>
          <el-table-column label="异常">
            <template slot-scope="scope">
              <span v-if="scope.row.isNormal == 0">异常</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间" :formatter="timefilter"></el-table-column>

        </el-table>

        <div class="page" >
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>




import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

export default {
  name: "BloodPressureAndHeartRate",
  data() {
    return {
      tableLoading:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      userCode: '',
      hh:this.$store.state.tableHeight-170,

    }
  },
  components: {

  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.hh = val - 170;
    },
    '$store.state.tableWidth' : function(val){
      console.log(val);
    },
  },
  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.getList();
    },
    closeSelf() {
      this.$emit("closeBlood");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DataAll/PageByUserCodeDeviceTypeValueType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceType: '',
          valueType:4,
          userCode: this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems=response.data.data.pageInfo.total
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

  }


}
</script>

<style lang="scss" scoped>


</style>
